import format from 'date-fns/format';

type PatternName = 'default' | 'datetime' | 'server';

export type Options = {
  patternName: PatternName;
};

function getPatternByPatternName(patternName: PatternName) {
  switch (patternName) {
    case 'datetime':
      return 'd.M.yyyy H:mm';
    case 'server':
      return "yyyy-MM-dd'T'00:00:00.000";
    default:
      return 'd.M.yyyy';
  }
}

export default function formatDate(date: Date, options?: Options) {
  const { patternName } = options || { patternName: 'default' };

  const pattern = getPatternByPatternName(patternName);

  return format(date, pattern);
}
